// extracted by mini-css-extract-plugin
module.exports = {"container":"confirmPassword_container_3OIWz","inputContainer":"confirmPassword_inputContainer_38Uqe","text":"confirmPassword_text_3P3mm","button":"confirmPassword_button_3zIXt"};